// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationLinks_NavigationLinks__JB9SD {
  --highlight-color: \$globalHighlightColor;
  display: flex;
  justify-content: center;
  flex: 1 1;
}
.NavigationLinks_NavigationLinks__JB9SD a {
  text-decoration: none;
  border-radius: 1rem;
}
.NavigationLinks_NavigationLinks__JB9SD .NavigationLinks_inactiveLinkDarkTheme__j76no {
  border-radius: 1rem;
  border: solid transparent;
  margin: 1rem;
  padding: 0.5rem;
  text-transform: uppercase;
  font-size: clamp(1.2rem, 3vw, 2.88rem);
  --highlight-color: #fafafa;
}
.NavigationLinks_NavigationLinks__JB9SD .NavigationLinks_inactiveLinkDarkTheme__j76no:hover {
  border: solid var(--highlight-color);
}
.NavigationLinks_NavigationLinks__JB9SD .NavigationLinks_inactiveLinkLightTheme__vOKJm {
  --highlight-color: #212121;
  border-radius: 1rem;
  border: solid transparent;
  margin: 1rem;
  padding: 0.5rem;
  text-transform: uppercase;
  font-size: clamp(1.2rem, 3vw, 2.88rem);
}
.NavigationLinks_NavigationLinks__JB9SD .NavigationLinks_inactiveLinkLightTheme__vOKJm:hover {
  border: solid var(--highlight-color);
}
.NavigationLinks_NavigationLinks__JB9SD .NavigationLinks_inactiveLinkColorfulTheme__k6JEt {
  --highlight-color: #454555;
  border-radius: 1rem;
  border: solid transparent;
  margin: 1rem;
  padding: 0.5rem;
  text-transform: uppercase;
  font-size: clamp(1.2rem, 3vw, 2.88rem);
}
.NavigationLinks_NavigationLinks__JB9SD .NavigationLinks_inactiveLinkColorfulTheme__k6JEt:hover {
  border: solid var(--highlight-color);
}
.NavigationLinks_NavigationLinks__JB9SD .NavigationLinks_activeLinkDarkTheme__hXowW {
  border-radius: 1rem;
  border: solid transparent;
  margin: 1rem;
  padding: 0.5rem;
  text-transform: uppercase;
  font-size: clamp(1.2rem, 3vw, 2.88rem);
  border: solid #fafafa;
}
.NavigationLinks_NavigationLinks__JB9SD .NavigationLinks_activeLinkLightTheme__AbyBn {
  border-radius: 1rem;
  border: solid transparent;
  margin: 1rem;
  padding: 0.5rem;
  text-transform: uppercase;
  font-size: clamp(1.2rem, 3vw, 2.88rem);
  border: solid #212121;
}
.NavigationLinks_NavigationLinks__JB9SD .NavigationLinks_activeLinkColorfulTheme__o8lUE {
  border-radius: 1rem;
  border: solid transparent;
  margin: 1rem;
  padding: 0.5rem;
  text-transform: uppercase;
  font-size: clamp(1.2rem, 3vw, 2.88rem);
  border: solid #212121;
}`, "",{"version":3,"sources":["webpack://./src/components/NavigationLinks/NavigationLinks.module.scss","webpack://./src/assets/_globalStyleElements.module.scss"],"names":[],"mappings":"AAEA;EACE,wCAAA;EACA,aAAA;EACD,uBAAA;EACC,SAAA;AADF;AAGE;EACE,qBAAA;EACA,mBCPiB;ADMrB;AAcE;EATE,mBCXiB;EDYjB,yBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,sCAAA;EAMA,0BAAA;AAPJ;AAQI;EACA,oCAAA;AANJ;AAUE;EACE,0BAAA;EAlBA,mBCXiB;EDYjB,yBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,sCAAA;AAWJ;AAII;EACE,oCAAA;AAFN;AAME;EACE,0BAAA;EA1BA,mBCXiB;EDYjB,yBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,sCAAA;AAuBJ;AAAI;EACE,oCAAA;AAEN;AAGE;EAlCE,mBCXiB;EDYjB,yBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,sCAAA;EA+BA,qBAAA;AAIJ;AADE;EAvCE,mBCXiB;EDYjB,yBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,sCAAA;EAoCA,qBAAA;AAQJ;AALE;EA5CE,mBCXiB;EDYjB,yBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,sCAAA;EAyCA,qBAAA;AAYJ","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.NavigationLinks {\n  --highlight-color : $globalHighlightColor;\n  display: flex;\n justify-content: center;\n  flex: 1;\n\n  a {\n    text-decoration: none;\n    border-radius: $globalBorderRadius;\n  }\n\n  @mixin generalLinkStyling {\n    border-radius: $globalBorderRadius;\n    border: solid transparent;\n    margin: 1rem;\n    padding: 0.5rem;\n    text-transform: uppercase;\n    font-size: clamp($globalFontSize, 3vw, $globalFontSize *2.4);\n  }\n\n\n  .inactiveLinkDarkTheme {\n    @include generalLinkStyling;\n    --highlight-color: #{$globalHighlightColorDark};\n    &:hover {\n    border: solid var(--highlight-color);\n  }\n  }\n\n  .inactiveLinkLightTheme {\n    --highlight-color: #{$globalDarkColor};\n    @include generalLinkStyling;\n    &:hover {\n      border: solid var(--highlight-color);\n    }\n  }\n\n  .inactiveLinkColorfulTheme {\n    --highlight-color: #{$globalHighlightColorLight};\n    @include generalLinkStyling;\n    &:hover {\n      border: solid var(--highlight-color);\n    }\n  }\n\n\n  .activeLinkDarkTheme {\n    @include generalLinkStyling;\n    border: solid $globalLightColor;\n  }\n\n  .activeLinkLightTheme {\n    @include generalLinkStyling;\n    border: solid $globalDarkColor;\n  }\n\n  .activeLinkColorfulTheme {\n    @include generalLinkStyling;\n    border: solid $globalDarkColor;\n  }\n}\n","$globalFontFamily: 'Courier New', monospace;\n$globalFontSize: 1.2rem;\n\n$globalBorderRadius: 1rem;\n$globalHomeContentContainerPadding: 2.5rem;\n\n$globalDarkColor: #212121;\n$globalLightColor: #fafafa;\n$globalUnderlayRGBAColorDark: rgba(255, 255, 255, 0.05);\n$globalUnderlayRGBAColorLight: rgba(208, 209, 255, 0.5);\n\n$globalHighlightColor: #f6a3a0;\n$globalHighlightColorDark: #fafafa;\n$globalHighlightColorLight: #454555;\n\n\n$colorsReact: #61dafb;\n$colorsKotlin: #7f52ff;\n$colorsReactRgba: rgba(97, 218, 251, 0.2);\n\n$gradientColor1: #845ec2;\n$gradientColor1: #d65db1;\n$gradientColor1: #ff9671;\n$gradientColor1: #ffc75f;\n$gradientColor1: #f9f871;\n\n@mixin darkTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalDarkColor;\n  color: $globalLightColor;\n  a {\n    color: white;\n  }\n}\n\n@mixin lightTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalLightColor;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin colorfulTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: #91f88b;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin darkThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorDark;\n}\n\n@mixin lightThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n\n@mixin colorfulThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NavigationLinks": `NavigationLinks_NavigationLinks__JB9SD`,
	"inactiveLinkDarkTheme": `NavigationLinks_inactiveLinkDarkTheme__j76no`,
	"inactiveLinkLightTheme": `NavigationLinks_inactiveLinkLightTheme__vOKJm`,
	"inactiveLinkColorfulTheme": `NavigationLinks_inactiveLinkColorfulTheme__k6JEt`,
	"activeLinkDarkTheme": `NavigationLinks_activeLinkDarkTheme__hXowW`,
	"activeLinkLightTheme": `NavigationLinks_activeLinkLightTheme__AbyBn`,
	"activeLinkColorfulTheme": `NavigationLinks_activeLinkColorfulTheme__o8lUE`
};
export default ___CSS_LOADER_EXPORT___;
